module.exports = __webpack_public_path__ + "static/media/24UHCHR4.e7d894b2.jpg";